import { LocalizedText } from "../types/types";

/** Icons in the requirements file are relative paths, absolute URLs are kept as they are. */
export const getIconUrl = (icon: string, baseUrl: string) =>
  /^https?:\/\//i.test(icon) ? icon : `${baseUrl}${icon}`;

/** Returns "de" for a German browser, "it" otherwise. */
export const getLanguage = () =>
  navigator.language.toLowerCase().startsWith("de") ? "de" : "it";

/** Returns the note in the given language, Italian if that language is missing. Also accepts the old plain string format. */
export const getNoteText = (note: LocalizedText | string, language: string) =>
  typeof note === "string" ? note : language === "de" ? note.de : note.it;
